import { u as useDomChangesObserver } from "./useDomChangesObserver-38254419.mjs";
import { g as getElementBackground } from "./utils-c8c02e41.mjs";
import { ref, onMounted } from "vue";
import { u as useColors } from "../useColors-cd2c0b98.mjs";
import { u as useEl } from "../useEl-3fe9f3d1.mjs";
import { T as TempMap } from "./TempMap-035b2408.mjs";
import { e as applyColors } from "../../services/color/utils-341c6fd7.mjs";
const isTransparent = (color) => color === "rgba(0, 0, 0, 0)";
const withCache = (cb) => {
  return (element, cache) => {
    if (!element) {
      return "#fff";
    }
    if (cache.has(element)) {
      return cache.get(element);
    }
    cache.set(element, cb(element, cache));
    return cache.get(element);
  };
};
const tempCache = new TempMap();
const useElementBackground = (element) => {
  const el = element || useEl();
  const { getColor } = useColors();
  const background = ref(getColor("background-primary"));
  const recursiveGetBackground = withCache((element2, cache) => {
    if (!element2) {
      return "#fff";
    }
    if (element2.nodeType !== Node.ELEMENT_NODE) {
      return recursiveGetBackground(element2.parentElement, cache);
    }
    const bg = getElementBackground(element2);
    if (!bg) {
      return recursiveGetBackground(element2.parentElement, cache);
    }
    if (isTransparent(bg)) {
      return recursiveGetBackground(element2.parentElement, cache);
    }
    return applyColors(recursiveGetBackground(element2.parentElement, cache), bg);
  });
  const updateBackground = (cache = tempCache) => {
    background.value = recursiveGetBackground(el.value, cache);
  };
  useDomChangesObserver(updateBackground, el);
  onMounted(updateBackground);
  return {
    background
  };
};
export {
  useElementBackground as u
};
//# sourceMappingURL=useElementBackground-bbb48795.mjs.map
